module.exports = __webpack_public_path__ + "static/media/main idea.545d16df.mp3";